import { HTMLAttributes, Ref } from "react"

import { classNames } from "../../../../lib/classNames"

export type TablePseudoBottomBorderRowProps =
  HTMLAttributes<HTMLTableRowElement> & {
    ref?: Ref<HTMLTableRowElement>
  }

// TablePseudoBottomBorderRow uses a pseudo element to create the bottom border of a table row.
// In tables with collapsed borders and sticky headers, there is a well-documented issue where
// our normally applied bottom row borders disappear on scroll. We apply the pseudo element to
// the th elements as opposed to the tr element because that works across browsers whereas pseudo
// elements with a relative tr element do not.
export function TablePseudoBottomBorderRow({
  children,
  className,
  ref,
  ...otherProps
}: TablePseudoBottomBorderRowProps) {
  return (
    <tr
      ref={ref}
      className={classNames(
        "[&>th]:relative",
        "[&>th]:after:absolute [&>th]:after:bottom-0 [&>th]:after:left-0 [&>th]:after:right-0 [&>th]:after:h-px",
        "[&>th]:after:bg-v2-border-default",
        className
      )}
      {...otherProps}
    >
      {children}
    </tr>
  )
}
